import React from 'react';
import ReactDOM from 'react-dom';

import { BrandPendulumMark } from './BrandPendulumMark';

import './SignupCreditAwardModal.css';

interface SignupCreditAwardModalProps {
  amount: number | null;
  onClose: () => void;
}

const formatCredits = (amount: number): string => new Intl.NumberFormat().format(amount);

export const SignupCreditAwardModal: React.FC<SignupCreditAwardModalProps> = ({ amount, onClose }) => {
  if (amount === null || !Number.isFinite(amount) || amount <= 0) return null;

  return ReactDOM.createPortal(
    <div className="signup-credit-award-overlay" onClick={onClose}>
      <div
        aria-labelledby="signup-credit-award-title"
        aria-modal="true"
        className="signup-credit-award-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <button aria-label="Close credit award" className="signup-credit-award-close" onClick={onClose} type="button">
          ×
        </button>
        <div aria-hidden="true" className="signup-credit-award-brand">
          <BrandPendulumMark className="signup-credit-award-brand-mark" />
          <span>8080.AI</span>
        </div>
        <p className="signup-credit-award-eyebrow">Signup reward unlocked</p>
        <h2 id="signup-credit-award-title">Welcome aboard!</h2>
        <div
          aria-label={`${formatCredits(amount)} credits added to your account`}
          className="signup-credit-award-credit"
        >
          <strong>{formatCredits(amount)}</strong>
          <span>
            <b>Credits</b>
            <small>added to your account</small>
          </span>
        </div>
        <p className="signup-credit-award-message">Your reward is ready to use.</p>
        <button className="signup-credit-award-button" onClick={onClose} type="button">
          Start building
        </button>
      </div>
    </div>,
    document.body,
  );
};
